import React from 'react'

import { Icon, InfoOutlined } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, shape, string } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function ValidationErrors({ errors = EMPTY_ARRAY }) {
  if (!errors || errors.length === 0) {
    return null
  }

  return (
    <div className="promote-modal__validation-errors">
      {errors.map((error) => (
        <div key={error.type} className="promote-modal__error-item">
          <Icon
            svgComponent={InfoOutlined}
            color="warning"
            size="small"
            notSpaced
            className="promote-modal__error-icon"
          />
          <span className="promote-modal__error-text">{error.message}</span>
        </div>
      ))}
    </div>
  )
}

ValidationErrors.propTypes = {
  errors: arrayOf(
    shape({
      type: string.isRequired,
      message: string.isRequired,
    })
  ),
}

export default ValidationErrors
